export default "__VITE_ASSET__xRR9maUF__"